/**
 * Extract an invitation token from a pasted invite URL, path, or bare token.
 * Tokens are SecureRandom.urlsafe_base64 (A-Za-z0-9_-=).
 */
export function parseInviteTokenInput(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const fromPath = trimmed.match(/\/invitations\/([^/?#]+)/);
  if (fromPath?.[1]) {
    try {
      return decodeURIComponent(fromPath[1]);
    } catch {
      return fromPath[1];
    }
  }

  if (/^[A-Za-z0-9_-]+=*$/.test(trimmed)) {
    return trimmed;
  }

  try {
    const url = new URL(trimmed);
    const match = url.pathname.match(/\/invitations\/([^/]+)\/?$/);
    if (match?.[1]) return decodeURIComponent(match[1]);
  } catch {
    // not a URL
  }

  return null;
}
